import React, { useEffect, useState } from "react";
import GenericTabs from "../../genericComponents/GenericTabs";
import SpotOpportunities from "./SpotOpportunities";
import WinOpportunities from "./winOpportunities";
import IncreaseDealSize from "./increaseDealSize";
import { useSearchParams } from "react-router-dom";


// const SpotOpportunities = () => {};



function MaximisePipeComp() {
  const [spotOpportunities,setSpotOpportunities]= useState([]);
const [, setSearchParams] = useSearchParams();
  useEffect(() => {
    setSearchParams({
      tab: "maximise_pipe",
      subTab: "spot_opportunitites",
    });
  }, []);
  


  const tabData = [
    { tabId:"spot_opportunitites",label: "Spot Opportunities", comp: <SpotOpportunities setSpotOpportunities={setSpotOpportunities}/> },
    { tabId:"win_opportunitites",label: "Win Opportunities", comp: <WinOpportunities spotOpportunities={spotOpportunities}/> },
    {tabId:"increase_deal_size", label: "Increase Deal Size", comp:  <IncreaseDealSize spotOpportunities={spotOpportunities}/>}
  ];

  return (
  
      <GenericTabs tabs={tabData} />

  );
}

export default MaximisePipeComp;
